<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    destroy-on-close
    :show-close="false"
    width="400px"
    custom-class="bindAccount__dialog onboarding__dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="bindAccount__dialog__container">
      <div>
        <p v-if="wechatAccount">首次使用微信登录</p>
        <p v-if="appleAccount">首次使用 Apple 登录</p>
        <p>请选择绑定已有账号或注册新账号</p>
      </div>
      <div class="bindAccount__dialog__container__btn">
        <div @click="clickBindAccount">绑定已有账号</div>
        <div @click="clickRegister">注册新账号</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import DBUtil from '@utils/DBUtil.js'
export default {
  name: 'BindAccountDialog',
  computed: {
    visible() {
      return this.$store.getters['wxLogin/showBindAccountDialog']
    },
    appleAccount() {
      return this.$store.getters['appleLogin/account']
    },
    wechatAccount() {
      return this.$store.getters['wxLogin/wechatAccount']
    },
  },
  methods: {
    clickRegister() {
      if (this.appleAccount) {
        this.handleAppleLogin()
      } else {
        this.$store.dispatch('wxLogin/updateBindAccountDialog', false)
        this.$router.push({
          name: 'register',
        })
      }
    },
    clickBindAccount() {
      this.$store.dispatch('wxLogin/updateBindAccountDialog', false)
      this.$router.push({
        name: 'bind_account',
      })
    },
    handleAppleLogin() {
      const { sub, email } = this.appleAccount
      this.$api.call(
        'POST',
        '/user/register/',
        {
          apple_sub: sub,
          email,
        },
        async (response) => {
          console.log('handleAppleLogin', response)
          this.$store.dispatch('wxLogin/updateBindAccountDialog', false)
          if (!response.data) {
            return
          }

          if (response.data.code == 0) {
            if (response.data.data.access_token) {
              this.$store.dispatch('updateUserInfo', response.data.data)
              await DBUtil.clearDB()
              // 有 access_token 才算登录成功
              setTimeout(() => {
                this.$router.replace({
                  name: 'mine',
                })
              }, 300)
            } else {
              this.$message.error(response.data.message)
            }
          }
        },
      )
    },
  },
}
</script>
<style lang="scss">
div.bindAccount__dialog {
  border-radius: 12px !important;
  &__header {
    color: rgba(0, 0, 0, 0.8);
    .close {
      position: absolute;
      top: -18px;
      right: -18px;
      cursor: pointer;

      .svg-icon {
        width: 36px !important;
        height: 36px !important;
        color: unset !important;
      }
    }
  }
  &__container {
    text-align: center;
    //padding: 30px;
    p {
      font-size: 16px;
      font-weight: 600;
      color: #454545;
      margin-top: 10px;
    }
    &__btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      div {
        background: var(--bgGreen);
        border-radius: 6px;
        font-size: 14px;
        border: 1px solid var(--loginBtnBorder);
        cursor: pointer;
        color: var(--memberPlanColor);
      }
    }
  }
}
</style>
<style lang="scss">
/* 平板及更大尺寸样式 */
@media screen and (max-width: 550px) {
  div.bindAccount__dialog {
    &__container {
      &__btn {
        div {
          padding: 11px 30px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
/* 桌面及更大尺寸样式 */
@media screen and (min-width: 700px) {
  div.bindAccount__dialog {
    &__container {
      &__btn {
        div {
          padding: 11px 45px;
        }
      }
    }
  }
}
</style>
